import { useReducer, createContext } from "react";

type FoldingBStateState = Record<string, Partial<FoldingBOptionState>>;

type FoldingBOptionState = Partial<{
	isOpen: boolean;
	flexGrow: number;
	ref: React.RefObject<HTMLDivElement>;
	bodyRef: React.RefObject<HTMLDivElement>;
	headRef: React.RefObject<HTMLDivElement>;
}>;

type FoldingBStatePayloadAction =
	| PayloadAction<{ id: string } & FoldingBOptionState, "register">
	| PayloadAction<{ id: string }, "unregister">
	| PayloadAction<{ id: string; meta: "click" | "system" }, "show">
	| PayloadAction<{ id: string; meta: "click" | "system" }, "hide">
	| PayloadAction<null, "showAll">
	| PayloadAction<null, "hideAll">;

export type FoldingBStateContextType = {
	state: FoldingBStateState;
	dispatch: React.Dispatch<FoldingBStatePayloadAction>;
};

export const FoldingBStateContext = createContext<FoldingBStateContextType | null>(null);

function reducer(state: FoldingBStateState, action: FoldingBStatePayloadAction) {
	switch (action.type) {
		case "register": {
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					...action.payload
				}
			};
		}
		case "unregister": {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { [action.payload.id]: _, ...rest } = state;
			return rest;
		}

		case "show":
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					isOpen: true,
					meta: action.payload.meta
				}
			};
		case "hide":
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					isOpen: false,
					meta: action.payload.meta
				}
			};
		case "showAll":
			return { ...state };
		case "hideAll":
			return { ...state };
		default:
			throw new Error("Unhandled action");
	}
}

const defaultReducerState = {} as FoldingBStateState;
export default function FoldingBContainer({ children }: { children: React.ReactNode }) {
	const [state, dispatch] = useReducer(reducer, defaultReducerState);

	return <FoldingBStateContext.Provider value={{ state, dispatch }}>{children}</FoldingBStateContext.Provider>;
}
